import { render } from "./MRJoinModal.vue?vue&type=template&id=dff7a1b4"
import script from "./MRJoinModal.vue?vue&type=script&lang=ts"
export * from "./MRJoinModal.vue?vue&type=script&lang=ts"
script.render = render

export default script